import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ListingEditPage from '../components/ListingEditPage'
import { actionCreators } from '@app/components/ListingEdit/modules/listingEdit'
import {
  IListingPageEditState,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectListing,
} from '../modules/listingEdit'

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IListingPageEditState>({
      isLoading: selectIsLoading(),
      isReady: selectIsReady(),
      isSaving: selectIsSaving(),
      listing: selectListing(),
    }),
    actionCreators,
  )(ListingEditPage),
)
